import { ENV } from '../../config/env';
import { trpc } from '../../config/trpc';
import { useAuth } from '../auth/useAuth';
import { useFrontChatBoot } from './useFrontChatBoot';

export const useFrontChat = ({ requestId }: { requestId?: number }) => {
  const { user } = useAuth();
  const { initialize } = useFrontChatBoot(document.body);

  // Just a helper to automatically cache
  const { data: frontSecret } = trpc.getFrontSecret.useQuery(undefined, {
    cacheTime: 600,
  });

  const handleChatSupport = () => {
    if (!initialize || !frontSecret) return;

    initialize({
      chatId: ENV.FRONT_CHAT_ID,
      token: frontSecret,
      email: user?.email,
      name: user?.full_name,
      requestId,
      useDefaultLauncher: true,
    });
  };

  return { handleChatSupport };
};
